"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortHelper = void 0;
/**
 * This sort helper uses a property selector to turn any complex propety into a string value
 * so that it can be sorted.  Property selectors should be added in order so that the primary
 * sort is first, followed by the secondary and so on.
 */
var SortHelper = /** @class */ (function () {
    function SortHelper() {
        this.sortProperties = Array();
    }
    SortHelper.prototype.AddSortProperty = function (propertySelector, direction) {
        this.sortProperties.push({ predicate: propertySelector, direction: direction || 'asc' });
        return this;
    };
    SortHelper.prototype.Sort = function (items) {
        var getSortFunc = function (direction, propertySelector, secondarySort) {
            var sortFunc = function (a, b) {
                var aValue = propertySelector(a).toUpperCase();
                var bValue = propertySelector(b).toUpperCase();
                if (aValue > bValue) {
                    return direction === 'asc' ? 1 : -1;
                }
                if (aValue < bValue) {
                    return direction === 'asc' ? -1 : 1;
                }
                if (secondarySort) {
                    return secondarySort(a, b);
                }
                return 0;
            };
            return sortFunc;
        };
        var prevSortFunc;
        for (var i = this.sortProperties.length - 1; i >= 0; i--) {
            var _a = this.sortProperties[i], direction = _a.direction, predicate = _a.predicate;
            prevSortFunc = getSortFunc(direction, predicate, prevSortFunc);
        }
        return __spreadArray([], items, true).sort(prevSortFunc);
    };
    return SortHelper;
}());
exports.SortHelper = SortHelper;
